import type { JobSkillDraft } from '../components/employer/job-skill-manager-row'
import type { OrganisationOpportunitySkill } from '../hooks/use-organisation-opportunities'

function skillListKey(
  skills: { skill_id?: string; id?: string; requirement_type: string }[],
): string {
  return JSON.stringify(
    skills
      .map((s) => ({ id: s.skill_id ?? s.id, rt: s.requirement_type }))
      .sort((a, b) => String(a.id).localeCompare(String(b.id))),
  )
}

export function jobSkillDraftsFromOpportunity(
  skills: OrganisationOpportunitySkill[],
): JobSkillDraft[] {
  return skills.map((s) => ({
    skill_id: s.skill_id ?? s.id,
    skill_name: s.skill_name,
    requirement_type: s.requirement_type as 'required' | 'preferred',
  }))
}

/** Apply remote skills when the agent (or API) wrote a different list. */
export function nextJobSkillDrafts(
  skills: OrganisationOpportunitySkill[],
  lastSerialized: string,
): { drafts: JobSkillDraft[] | null; serialized: string } {
  const serialized = skillListKey(skills)
  if (serialized === lastSerialized) {
    return { drafts: null, serialized }
  }
  return { drafts: jobSkillDraftsFromOpportunity(skills), serialized }
}
